import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { useParams } from "react-router-dom";

import {
  ModalDialog,
  Button,
  Icon,
  COLORS,
  BREAKPOINTS
} from "@onelogin/react-components";
import { SMALL_MODAL_SIZE, MOBILE_VIEW_LIMIT } from "../../constants/Env";

const Warning = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 24px;
  line-height: 1.71;
  flex-grow: 1;

  @media screen and (max-width: ${MOBILE_VIEW_LIMIT}) {
    flex-direction: column;
    padding: 24px 20px;
    line-height: 1.5;
  }
`;

const WarningIcon = styled.div`
  margin-right: 16px;

  @media screen and (max-width: ${MOBILE_VIEW_LIMIT}) {
    margin-right: 0;
    margin-bottom: 21px;
  }
`;

const WarningMessage = styled.div`
  width: 100%;
  font-size: 14px;

  @media screen and (max-width: ${MOBILE_VIEW_LIMIT}) {
    font-size: 16px;
  }
`;

const DialogFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props => (props.horizontalCenter ? "center" : "flex-end")};
  border-top: solid 1px ${COLORS.SEPARATOR_COLORS.MEDIUM};
  padding: 16px 24px;

  @media screen and (max-width: ${BREAKPOINTS.PHONE_LARGE}) {
    border: 1px solid ${COLORS.GRAY_COLORS.GRAY_94};
    background-color: ${COLORS.GRAY_COLORS.GRAY_98};
    padding: 12px;
    display: flex;
    justify-content: center;
  }
`;

const StyledButton = styled.div`
  margin-left: 12px;

  &:first-child {
    margin-left: 0px;
  }
  @media screen and (max-width: ${BREAKPOINTS.PHONE_LARGE}) {
    width: 50%;
  }
`;

const RemoveWarningButton = styled(Button)`
  @media screen and (max-width: ${BREAKPOINTS.PHONE_LARGE}) {
    width: 100%;
  }
`;

const RemoveNoteWarning = ({ onRemove, onCloseRemoveModal }) => {
  const { id } = useParams();
  return (
    <ModalDialog
      fixedWidth={SMALL_MODAL_SIZE}
      onClose={onCloseRemoveModal}
      closeOnEscape
      closeOnClick
    >
      <ModalDialog.Header>
        <FormattedMessage
          id="removeNoteWarningHeader"
          defaultMessage="Remove Note"
        />
      </ModalDialog.Header>

      <Warning>
        <WarningIcon>
          <Icon name="Warning-24" size="44px" />
        </WarningIcon>

        <WarningMessage>
          <FormattedMessage
            id="removeNoteWarningContent"
            defaultMessage="Are you sure you want to delete this note?"
          />
        </WarningMessage>
      </Warning>

      <DialogFooter>
        <StyledButton>
          <RemoveWarningButton
            size="medium"
            onClick={onCloseRemoveModal}
            data-testid="cancel-button"
          >
            <FormattedMessage id="cancel" defaultMessgae="Cancel" />
          </RemoveWarningButton>
        </StyledButton>
        <StyledButton>
          <RemoveWarningButton
            size="medium"
            look="primary"
            onClick={() => onRemove(id)}
            data-testid="remove-button"
          >
            <FormattedMessage id="remove" defaultMessgae="Remove" />
          </RemoveWarningButton>
        </StyledButton>
      </DialogFooter>
    </ModalDialog>
  );
};

export default RemoveNoteWarning;
